(function ($) {
    'use strict';

    const adjustBtnPosition = function () {
        let $btn = $('.js-scroll-to-top-btn');
        if ($btn.length) {
            let scrollRect = $btn.parent().get(0).getBoundingClientRect();
            scrollRect = scrollRect.top + (window.innerHeight / 2);
            let topMargin = window.innerHeight / 2;
            
            $btn.toggleClass('fixed', scrollRect <= topMargin);
        }
    };

    $(document).on('click', '.js-scroll-to-top-btn', function (e) {
        $(window).scrollTop(0);
    });

    $(window).on('scroll resize load', adjustBtnPosition);
})(jQuery);